<template>
	<div id="qrcode"></div>
</template>
<script>
	import QRCode from 'qrcodejs2'
	export default {
		name:'qrCode',
		props:['hash'],
		data(){
			return {
				srcVal:''
			}
		},
		methods: {
			qrcode () {
				let me = this;
				me.srcVal = window.location.href;
		      	let qrcode = new QRCode('qrcode', {
		        	width: 100,
		        	height: 100, // 高度
		        	text: me.srcVal + me.hash // 二维码内容
		        	// render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
		        	// background: '#f0f'
		        	// foreground: '#ff0'
		      	})
		      	// console.log(qrcode)
		    }
		},
		mounted () {
		    this.qrcode()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/qr-code.vue